// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-container-module--footer--2fWPe"};